export default __webpack_public_path__ + "static/7-things-a-platinum-credit-card-can-do-for-you-af2c29f593a44518bc269a564e6ba440.jpg";